import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import type { DrawerT } from './drawer-stack';
import { closeAllDrawersAtom, closeDrawerAtom, drawersAtom, openDrawerAtom } from './drawer-stack';
export function useDrawer() {
  const openAtom = useSetAtom(openDrawerAtom);
  const closeAtom = useSetAtom(closeDrawerAtom);
  const closeAllAtom = useSetAtom(closeAllDrawersAtom);
  const drawers = useAtomValue(drawersAtom);
  const open = useCallback((drawer: DrawerT) => openAtom(drawer), [openAtom]);
  const close = useCallback((data?: unknown) => closeAtom(data), [closeAtom]);
  const closeAll = useCallback(() => closeAllAtom(), [closeAllAtom]);
  return {
    open,
    close,
    closeAll,
    stack: drawers,
    isOpen: drawers.length > 0
  };
}